export default __webpack_public_path__ + "static/media/988.1aa0b193.png";